import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";

export const FunnelQuiz = ({ questions, qIndex, answers, openAnswer, setOpenAnswer, selectChoice, nextQuestion }) => {
  const q = questions[qIndex];
  return (
    <motion.div key={`q-${qIndex}`} initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -40 }}>
      <p className="text-xs text-purple-400 font-semibold mb-2">Pregunta {qIndex + 1} de {questions.length}</p>
      <h2 className="font-display font-bold text-2xl mb-6">{q.text}</h2>
      {q.type === "choice" ? (
        <div className="space-y-3">
          {q.options.map((opt, i) => (
            <button
              key={opt}
              data-testid={`quiz-option-${i}`}
              onClick={() => selectChoice(q, opt)}
              className={`w-full text-left rounded-xl border px-5 py-4 transition-all hover:-translate-y-0.5 ${answers[q.id] === opt ? "border-yellow-400 bg-yellow-400/10" : "border-white/15 bg-[#121212] hover:border-purple-500"}`}
            >
              {opt}
            </button>
          ))}
        </div>
      ) : (
        <div>
          <Textarea data-testid="quiz-open-answer" value={openAnswer} onChange={(e) => setOpenAnswer(e.target.value)} rows={4} placeholder="Escribe aquí..." className="bg-black border-white/15 rounded-xl focus-visible:ring-purple-500" />
          <Button data-testid="quiz-next" onClick={nextQuestion} className="w-full bg-purple-600 hover:bg-purple-500 rounded-xl py-6 mt-4">
            Continuar <ArrowRight size={18} className="ml-2" />
          </Button>
        </div>
      )}
    </motion.div>
  );
};

export const FunnelContact = ({ funnel, hasQuiz, contact, setContact, submit }) => (
  <motion.div key="contact" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} className="rounded-2xl border border-white/10 bg-[#0d0d0d] p-7 glow-purple">
    <h3 className="font-display font-bold text-xl text-center mb-1">¡Último paso! 🚀</h3>
    <p className="text-sm text-zinc-400 text-center mb-5">Déjanos tus datos para enviarte la información.</p>
    <div className="space-y-4">
      <FunnelContactFields contact={contact} setContact={setContact} hasQuiz={hasQuiz} />
      <Button data-testid="lead-submit-button" onClick={submit} className="w-full bg-yellow-400 hover:bg-yellow-300 text-black font-bold rounded-xl py-6 text-base">
        {funnel.cta_text || "Ver mi resultado"}
      </Button>
    </div>
  </motion.div>
);

const FunnelContactFields = ({ contact, setContact, hasQuiz }) => (
  <>
    <Input data-testid="lead-name-input" value={contact.name} onChange={(e) => setContact({ ...contact, name: e.target.value })} placeholder="Tu nombre completo" className="bg-black border-white/15 rounded-xl py-6 focus-visible:ring-purple-500" />
    <Input data-testid="lead-phone-input" value={contact.phone} onChange={(e) => setContact({ ...contact, phone: e.target.value })} placeholder="Tu WhatsApp (con código de país)" inputMode="numeric" className="bg-black border-white/15 rounded-xl py-6 focus-visible:ring-purple-500" />
    <Input data-testid="lead-email-input" value={contact.email} onChange={(e) => setContact({ ...contact, email: e.target.value })} placeholder="Tu correo (opcional)" type="email" className="bg-black border-white/15 rounded-xl py-6 focus-visible:ring-purple-500" />
    {!hasQuiz && (
      <Textarea data-testid="lead-message-input" value={contact.message} onChange={(e) => setContact({ ...contact, message: e.target.value })} rows={3} placeholder="¿Por qué te interesa? (opcional)" className="bg-black border-white/15 rounded-xl focus-visible:ring-purple-500" />
    )}
  </>
);
